import React, { useEffect } from "react";

export default function MasterclassThankYouModal({ onClose }) {

    useEffect(() => {
        if (window.fbq) {
            window.fbq("track", "CompleteRegistration");
        }
    }, []);

    return (
        <>
            <section
                style={{
                    maxWidth: "1200px",
                    margin: "0 auto",
                    padding: "40px 24px",
                    background: "#ffffff",
                    borderRadius: "20px",
                    boxShadow: "0 12px 30px rgba(0,0,0,0.08)",
                    textAlign: "center"
                }}
            >
                <h2
                    style={{
                        fontFamily: "'Poppins', sans-serif",
                        fontSize: "32px",
                        fontWeight: "700",
                        color: "#ff008e",
                        marginBottom: "20px"
                    }}
                >
                    🎉 You’re In. Your Seat Is Reserved
                </h2>

                <p style={{ fontSize: "18px", lineHeight: "1.7", marginBottom: "16px" }}>
                    You’ve successfully registered for{" "}
                    <strong>Myprega’s Private Pregnancy Masterclass</strong>.
                </p>

                <p style={{ fontSize: "18px", lineHeight: "1.7", marginBottom: "16px" }}>
                    Take a deep breath — you’ve just taken a thoughtful step for yourself and your baby.
                </p>

                <p style={{ fontSize: "18px", lineHeight: "1.7", marginBottom: "16px" }}>
                    Pregnancy — especially the first trimester — can feel confusing, overwhelming, and lonely at times.
                    When you’re managing work, responsibilities, and expectations, it’s natural to wonder:
                    <strong> “Am I doing enough for my baby?”</strong>
                </p>

                <p style={{ fontSize: "18px", lineHeight: "1.7", marginBottom: "16px" }}>
                    By registering for this session, you’ve chosen <strong>clarity over confusion</strong> and{" "}
                    <strong>prevention over panic</strong>.
                </p>

                <p style={{ fontSize: "18px", lineHeight: "1.7", marginBottom: "24px" }}>
                    You’re not alone in this journey. We’re honoured to walk this part of your pregnancy with you.
                </p>

                <h3 style={{ fontSize: "22px", fontWeight: "700", marginBottom: "16px" }}>
                    Before you go, please watch this short welcome message from our doctor.
                </h3>

                <div
                    style={{
                        position: "relative",
                        width: "100%",
                        maxWidth: "720px",
                        margin: "0 auto",
                        aspectRatio: "16 / 9",
                        borderRadius: "16px",
                        overflow: "hidden",
                    }}
                >
                    <iframe
                        src="https://drive.google.com/file/d/1uUczDg5LzIBrktL3ljEywWuJCctCQQqK/preview"
                        width="100%"
                        height="100%"
                        allow="autoplay"
                        allowFullScreen
                        style={{
                            position: "absolute",
                            top: 0,
                            left: 0,
                            width: "100%",
                            height: "100%",
                            border: "none",
                        }}
                    />
                </div>

                <p style={{ fontSize: "16px", lineHeight: "1.7", marginTop: "8px" }}>
                    Your privacy matters deeply to us. Your information will only be used for this masterclass.
                </p>
            </section>

            <button
                onClick={onClose}
                style={{
                    marginTop: "30px",
                    background: "#005cff",
                    color: "#fff",
                    border: "none",
                    padding: "14px 28px",
                    borderRadius: "40px",
                    fontSize: "16px",
                    cursor: "pointer"
                }}
            >
                Close
            </button>
        </>
    );
}
